import { useClass } from '@/hooks/useClass'

export const IconBase = ({
  children,
  className,
  ...props
}: React.ComponentProps<'svg'>) => {
  const svgClass = useClass('fill-current', className)
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="1em"
      className={svgClass}
      {...props}
    >
      {children}
    </svg>
  )
}
